import { getAPIUrl, Post } from "../../apiMethods";

export const authendpoint = {
  login: "restaurant/auth/login",
  customerRegister: "restaurant/customer/send-otp-customer",
  customerOtpVerify: "restaurant/customer/otp-verify",
};

export const RestaurentLogin = (data, param = "") => {
  const url = getAPIUrl(authendpoint.login, param);
  return Post(url, data, false);
};

export const CustomerRegister = (data, param = "") => {
  const url = getAPIUrl(authendpoint.customerRegister, param);
  return Post(url, data);
};

export const CustomerOtpVerify = (data, param = "") => {
  const url = getAPIUrl(authendpoint.customerOtpVerify, param);
  return Post(url, data);
};
